import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";

function Other() {
  useEffect(() => {
    // insert script tag
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_CS_JS_SCRIPT;
    // add charitystack-embed as id
    script.id = "charitystack-embed";
    // set data-id to M_glZDDEVkfj
    script.dataset.id = "M_dby7G6Xtc5";
    // make script defer
    script.defer = true;
    // append script to head
    document.body.appendChild(script);
  }, []);
  return (
    <div className="App">
      <div>This is some placeholder text above</div>

      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="1ee672b7-2d0e-4e4c-bb27-8abd886a5946"
      ></div>
      <div>This is some placeholder text below</div>
    </div>
  );
}

export default Other;
